import { Fancybox as NativeFancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { useEffect, useRef } from 'react';

export default function Fancybox({ children, delegate = '[data-fancybox]', options = {} }) {
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;

    const opts = {
      ...options,
      iframe: {
        preload: false,
        css: {
          width: '80%',
          height: '80%',
        },
        attr: {
          allow: 'autoplay; fullscreen; picture-in-picture; encrypted-media',
          allowfullscreen: true,
        },
      },
      dragToClose: false,
      animated: true,
      showClass: 'fancybox-fadeIn',
      hideClass: 'fancybox-fadeOut',
      click: false,
      closeButton: 'inside',
      trapFocus: true,
      autoFocus: false,
    };

    NativeFancybox.bind(delegate, opts);

    return () => {
      isMounted.current = false;
      setTimeout(() => {
        if (!isMounted.current) {
          NativeFancybox.unbind(delegate);
          NativeFancybox.close();
        }
      }, 100);
    };
  }, [delegate]);

  return <>{children}</>;
}
